import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { useCoinStore } from '../stores/coinStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, getCurrentUser, logout } = useAuthStore();
  const { account, loadAccount } = useCoinStore();
  const location = useLocation();
  const [checking, setChecking] = React.useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      logout();
      setChecking(false);
      return;
    }

    setChecking(true);
    getCurrentUser().finally(() => {
      setChecking(false);
    });
  }, [getCurrentUser, logout]);

  useEffect(() => {
    if (isAuthenticated && !account) {
      loadAccount();
    }
  }, [isAuthenticated, account, loadAccount]);

  if (isLoading || checking) {
    return (
      <div className="flex justify-center items-center h-screen bg-bg-page">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="mt-4 text-gray-400 font-medium">加载中...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
